import React from 'react'
import get from 'lodash/get'
import _ from 'lodash'
import Helmet from 'react-helmet'
// import styles from './index.module.css'
import podStyles from './podcast.module.css'
// import { podcasts } from '../data/podcasts.js'
import { specialPodcasts } from '../data/podcasts.js'

class PodcastIndex extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')

    // const posts = _.sortBy(podcasts, "episode")
    const jsonPosts = get(this.props, 'data.contentfulJsonData').jsonData
    const sortedPosts = _.sortBy(jsonPosts, "episode")
    const specialPosts = _.sortBy(specialPodcasts, "order")
    const siteData = get(this.props, 'data.site.siteMetadata')
    const siteDescription = 'YOUCAT Indonesia membantu formasio pendamping anak muda dalam pengembangan iman Katolik dengan menyediakan materi pembinaan terutama bagi para pendamping anak muda dalam mempersiapkan anak muda menjadi saksi iman di tengah masyarakat'

    // const post = get(this.props, 'data.contentfulJsonData')
    // console.log(post)

    return (
      <div style={{ background: '#fff' }} className="page-content">
        <Helmet title={`Podcast Peziarah | YOUCAT Indonesia`}>

          <link rel="canonical" href={`${siteData.siteUrl}/podcast/`} />
          <meta name="description" content={`${siteDescription}`} />
          <meta name="title" content={`Podcast Peziarah | YOUCAT Indonesia`} />

          <meta property="og:title" content={`Podcast Peziarah | YOUCAT Indonesia`} />
          <meta property="og:site_name" content="YOUCAT Indonesia" />
          <meta property="og:url" content={`${siteData.siteUrl}/podcast`} />
          <meta property="og:description" content={`${siteDescription}`}  />
          <meta property="og:image" content="https://static.youcat.id/ogimg/ogimg-youcat.png" />
          <meta property="og:locale" content="id_ID" />
          <meta property="og:type" content="website" />

        </Helmet>
        <h1 className="page-title">Podcast Peziarah</h1>
        <section className="section-podcasts">
          <ul className="list-group">
            { _.map(sortedPosts, function(x, index ) {
              return (
                <li key={index} className={`${podStyles.docItem}`}>
                  <div className={`podcast-list-item`}>
                    <div className={`title ${podStyles.docTitle}`}>
                      <span className={`${podStyles.episode}`}>{x.episode}</span>{x.judul}
                    </div>
                    <div className={`excerpt ${podStyles.excerpt}`}>
                      {x.description}
                    </div>
                    <div className={`grid-x align-right text-right`}>
                      <div className={`button-group cell shrink`}>
                        <a className={`${podStyles.spotifyButton} button button-primary`} rel="noreferrer" href={x.tautan.spotify} target="_blank" title="Spotify"> Spotify </a>
                        <a className={`${podStyles.anchorButton} button button-primary`} rel="noreferrer" href={x.tautan.anchor} target="_blank" title="Anchor"> Anchor </a>
                      </div>
                    </div>
                  </div>
                </li>
              )
            }) }
          </ul>
        </section>
        {/* <section className="section-podcasts">spotify
          <ul className="list-group">
            { _.map(specialPosts, function(x, index ) {
              return (
                <li key={index} className={`${podStyles.docItem}`}>
                  <div className={`podcast-list-item`}>
                    <div className={`title ${podStyles.docTitle}`}>
                      <span className={`${podStyles.episode}`}>Special {x.order}</span>{x.tautan}
                    </div>
                    <div className={`excerpt ${podStyles.excerpt}`}>
                      {x.description}
                    </div>
                    <div className={`grid-x align-right text-right`}>
                      <div className={`button-group cell shrink`}>
                        <a className={`${podStyles.spotifyButton} button button-primary`} rel="noreferrer" href={x.tautan.spotify} target="_blank" title="Spotify"> Spotify </a>
                        <a className={`${podStyles.anchorButton} button button-primary`} rel="noreferrer" href={x.tautan.anchor} target="_blank" title="Anchor"> Anchor </a>
                      </div>
                    </div>
                  </div>
                </li>
              )
            }) }
          </ul>
        </section> */}
      </div>
    )
  }
}

export default PodcastIndex

export const pageQuery = graphql`
  query PodcastsQuery {
    site {
      siteMetadata {
        title
        siteUrl
        siteImg
      }
    }
    contentfulJsonData(slug: { eq: "podcastData" }) {
      title
      jsonData {
        judul
        episode
        description
        tautan {
          anchor
          spotify
        }
      }
    }
  }
`







// WEBPACK FOOTER //
// ./src/pages/podcast.js